import React from 'react';
import { c as classnames } from '../../index-2586sEvh.js';
import CircularProgress from '../CircularProgress/index.js';
import '../../_commonjsHelpers-jjO7Zipk.js';

const Loader = ({ size = 28, padding = 0, center = false, fullScreen = false, className, }) => (React.createElement("div", { className: classnames('base-loader', { 'full-screen': fullScreen, center }, className), style: { padding } },
    React.createElement(CircularProgress, { size: size })));

export { Loader as default };
//# sourceMappingURL=index.js.map
